import { IAppState } from '../../../AppModulesWrapper';
import { IAuctionState } from '../../types/reducers/auction';

export const selectAuction = (state: IAppState): IAuctionState => {
  return state.servicePickerWidget.auction;
};
